module.exports = __webpack_public_path__ + "static/img/activity_pic_big.jpg";